// extracted by mini-css-extract-plugin
export default {"collapseTitle":"Collapse_collapseTitle__80BH3"};